import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import { CreateButton, List, ListActions, Title, useStore } from "react-admin";
import { checkPermission } from "server/security/utils";
import CustomFilter from "features/CustomFilter";
import useScheduleFilter from "features/filters/useScheduleFilter";
import WeeklyScheduleTable from "./components/WeeklyScheduleTable";
import { Box, Typography, Paper, useMediaQuery } from "@mui/material";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { mguExporter } from "utils/tenants";

const STORE_KEY = "weeklySchedule.filters";

const ListWeeklySchedule = () => {
  const userPermissions = getPermissions();

  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const [filters, setFilters] = useStore(STORE_KEY, null);
  const schedule = useScheduleFilter({ filters });

  const handleSearch = selectedFilters => {
    setFilters(selectedFilters);
  };

  return (
    <>
      {!filters && <Title title={"Седмично разписание"} />}
      <CustomFilter
        title="Избери разписание"
        cardWidth={isMobile ? "100%" : "700px"}
        filters={schedule.fields}
        buttonLabel="Покажи"
        buttonDisabled={!schedule.isComplete}
        buttonOnClick={() => handleSearch(schedule.query)}
      />
      {!filters ? (
        <Paper sx={{ mt: 5 }}>
          <Box
            p={2}
            sx={{ display: "flex", justifyContent: "center", gap: 3 }}
          >
            <Typography
              align="center"
              color="secondary"
            >
              Въведи филтри за седмично разписание или създай ново.
            </Typography>
            <CreateButton />
          </Box>
        </Paper>
      ) : (
        <List
          title="Седмично разписание"
          actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateWeeklySchedule)} />}
          filter={filters}
          exporter={mguExporter}
        >
          <WeeklyScheduleTable />
        </List>
      )}
    </>
  );
};

export default ListWeeklySchedule;
